// extracted by mini-css-extract-plugin
export default {"wrapper":"decreesList_wrapper__iyeAt"};